export default __webpack_public_path__ + "static/02-01-writing-responses-3411492ad317fea7ff91ea3ff24438c1.mp4";